import React from 'react'

const Spinner = ({ children }) => (
  <div className="d-flex justify-content-center App-loader">
    <div className="App-loader-image"></div>
    {children !== undefined ?
      <div className="App-loader-text">{children}</div>
    :
      null
    }
  </div>
)

export default Spinner


// WEBPACK FOOTER //
// ./src/components/Spinner.js